import { Box, Stack, Typography } from '@mui/material';
import '../styles/Section3.scss';
import sectionConstants from '../../constants/SectionConstants';
import { Zoom } from "react-awesome-reveal";


 const Session3 = () => {
  return (
    <Box>
      <Box>
        <Box className='landing-image'>
          <Zoom>
          <Stack className='typo-content'>
            <Typography className='typo-heading'>
            {sectionConstants.EnhanceYourFleet}
            </Typography>

            <Typography className='typo-para'>
             {sectionConstants.Discoverthepower}
            </Typography>
            <Typography className='typo-para'>
             {sectionConstants.Discover}
            </Typography>
            <Typography className='typo-para'>
             {sectionConstants.Enjoy}
            </Typography>
          </Stack>
          </Zoom>
        </Box>
      </Box>
    </Box>
  );
};
export default Session3;
